import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "../../lib/constants";

export const Products = () => {
  return (
    <section
      id="products"
      data-testid="products-section"
      className="bg-white py-20 sm:py-28 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] ping-gradient-text mb-4">
            Our products
          </p>
          <h2 className="text-4xl sm:text-5xl lg:text-[3.5rem] lg:leading-[1.05] font-black tracking-tight text-[#1A1A2E]">
            Four products. <br className="hidden sm:block" />
            <span className="ping-gradient-text">One platform.</span>
          </h2>
          <p className="mt-5 text-lg text-gray-600 max-w-2xl">
            Purpose-built WhatsApp notification tools for UAE service
            businesses.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {PRODUCTS.map((product, i) => (
            <motion.article
              key={product.id}
              data-testid={product.testId}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="group relative bg-white border border-gray-200/80 rounded-3xl p-7 sm:p-9 hover:border-[#7B5EA7]/40 hover:shadow-2xl hover:shadow-gray-200/70 hover:-translate-y-1.5 transition-all duration-300 overflow-hidden"
            >
              {/* Subtle gradient backdrop */}
              <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full ping-gradient opacity-0 group-hover:opacity-[0.06] blur-3xl transition-opacity duration-500" />

              <div className="relative flex items-start justify-between gap-4 mb-6">
                <div className="w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center group-hover:scale-105 transition-transform">
                  <img
                    src={product.logo}
                    alt={`${product.name} logo`}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <div className="opacity-0 group-hover:opacity-100 -translate-y-1 group-hover:translate-y-0 transition-all duration-300">
                  <div className="w-10 h-10 rounded-full ping-gradient flex items-center justify-center">
                    <ArrowUpRight size={18} className="text-white" />
                  </div>
                </div>
              </div>

              <h3 className="text-2xl sm:text-3xl font-black tracking-tight ping-gradient-text mb-1.5">
                {product.name}
              </h3>
              <p className="text-sm font-medium text-gray-500 mb-4 leading-snug">
                {product.caption}
              </p>
              <p className="text-[15px] leading-relaxed text-gray-700">
                {product.description}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
